// Per-component import path — this repo does not use a barrel export.
import { Badge } from '@marine/ui/badge';

const LABELS = {
  pending: 'Provisioning…',
  converging: 'Provisioning…',
  failed: 'Provisioning failed',
} as const;

type ProvisioningStatus = keyof typeof LABELS | 'ready';

export function ProvisioningStatusBadge({ status }: { status: ProvisioningStatus }) {
  // `ready` is the steady state — no badge, so the list stays quiet.
  if (status === 'ready') return null;

  const label = LABELS[status];

  return (
    <Badge
      variant={status === 'failed' ? 'destructive' : 'secondary'}
      size="sm"
      aria-label={`Tenant provisioning status: ${label}`}
    >
      {label}
    </Badge>
  );
}
